var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_gif"},[_c('div',{staticClass:"loader_spinner",class:{ dark: _vm.current_theme === 'dark' }})])
}
var staticRenderFns = []

export { render, staticRenderFns }